const state = {
    accounts: [],
};

export default state;
